import Services from '../../services'
import {splitIdsCollection} from "../../utils/store";
import {asyncForEach} from "../../utils/array";
import hash from 'object-hash';
import Vue from "vue";

const state = {
  moderation: {},
  moderationGroup: {},
};

// getters
const getters = {
  moderation: (state) => id => {
    return state.moderation[id];
  },
  moderationGroupByAsset: (state) => assetId => {
    return _.find(state.moderationGroup, g => g.asset === assetId);
  },
};

// actions
const actions = {
  async fetchModerationItem({dispatch, commit}, moderationId) {
    if(state.moderation[moderationId]) {
      return;
    }

    dispatch('wait/start', `moderation.${moderationId}.fetch`, {root: true});

    const data = await Services.Moderation.fetchModerationItem(moderationId);
    await dispatch('pushModeration', data);

    dispatch('wait/end', `moderation.${moderationId}.fetch`, {root: true});

  },

  async fetchModerationGroupByAsset({commit, state, dispatch, rootGetters}, assetId) {
    if(_.find(state.moderationGroup, m => m.asset === assetId)) {
      return;
    }

    const data = await Services.Auth.fetchModerationGroup(assetId, rootGetters['auth/token']);
    await dispatch('pushModerationGroup', data);
  },

  async fetchModerationGroupByFilter({commit, state, dispatch, rootGetters}, filter) {
    const data = await Services.Moderation.fetchModerationGroupsByFilter(filter);
    await dispatch('pushModerationGroup', data);
  },

  async pushModerationGroup({commit, state, dispatch, rootGetters}, group) {
    if(state.moderationGroup[group.id]) {
      return;
    }

    const { ids: moderationIds, objects: moderationObjects } = splitIdsCollection(group.moderation);

    await dispatch('pushModeration', moderationObjects);

    group.moderation = moderationIds.concat(moderationObjects.map(m => m.id));

    commit('addModerationGroup', {id: group.id, group});
  },

  async pushModeration({commit, state, dispatch, rootGetters}, moderation) {
    moderation = _.isArray(moderation) ? moderation : [moderation];

    moderation.forEach(m => {
      if(!state.moderation[m.id]) {
        commit('addModeration', {id: m.id, moderation: m});
      }
    })
  }
};

// mutations
const mutations = {
  updateModerationEval(state, {id, evaluate}) {
    console.log(id, evaluate);
    Vue.set(state.moderation[id], 'evaluate', evaluate);

    // state.moderation[id].evaluation = evaluation;
  },
  addModeration(state, {id, moderation}) {
    Vue.set(state.moderation, id, moderation);
    // state.moderation[id] = moderation;
  },
  addModerationGroup(state, {id, group}) {
    state.moderationGroup[id] = group;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/moderation.js